export const Services = {
   "TICKETS": {
      "path": "https://servicedeskapitickets.azurewebsites.net/"
   },
   "REPORT_SERVICE": {
      "path": "https://servicereportapi.azurewebsites.net",
      "descrp": "API Reportes"
   }
}